import { render } from "./CompactPost.vue?vue&type=template&id=6f39b2c4"
import script from "./CompactPost.vue?vue&type=script&lang=js"
export * from "./CompactPost.vue?vue&type=script&lang=js"

import "./CompactPost.vue?vue&type=style&index=0&id=6f39b2c4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__